import { render } from "./PSPDFKitContainer.vue?vue&type=template&id=56b8e72e&scoped=true"
import script from "./PSPDFKitContainer.vue?vue&type=script&lang=js"
export * from "./PSPDFKitContainer.vue?vue&type=script&lang=js"

import "./PSPDFKitContainer.vue?vue&type=style&index=0&id=56b8e72e&lang=sass&scoped=true"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56b8e72e"]])

export default __exports__